<div>
  <div class="bottom-space">
    <button mat-stroked-button color="primary" type="button" (click)="onClick()">
      {{text}}
    </button>
  </div>
  <div>
    <mat-error *ngIf="!selected "> Please select a file</mat-error>
    <div class="bofa--heading is-8 bold " *ngFor="let file of files">
      <mat-chip-listbox #chipList aria-label="File selection">
        <mat-chip-option [selectable]="selectable">
          {{file.data.name}}
        </mat-chip-option>
      </mat-chip-listbox>
      <mat-error class="top-space" *ngIf="file.canRetry"> {{file.error}}</mat-error>
    </div>
  </div>
</div>

<div class="flex-container">
  <div class="fx-flex-85">
    <ul class="padd-15">
      <li *ngFor="let file of files" [@fadeInOut]="file.state">
        <mat-progress-bar class="bottom-space" [value]="file.progress"></mat-progress-bar>
        <button class="bofa--button secondary outlined" (click)="retryFile(file)" *ngIf="file.canRetry">
          Retry upload
        </button>
      </li>
    </ul>
  </div>
</div>

<label for="fileUpload" class="bofa--skiplink">Upload file</label>
<input type="file" id="fileUpload" #fileUpload name="fileUpload" class="fileUpload"  />